import { Box } from '@mui/material'
import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { DataQualityMUITable } from './DataQuality.MuiTable'
import { useDataQuality, useFetchColumnData } from './DataQuality.data'
import { Loader } from 'Common/Loader/Loader'
import { GridCellParams } from '@mui/x-data-grid-premium'
import toast from 'react-hot-toast'
import { DataQualityCheckModal } from './DataQualityCheck.Modal'
import { useState } from 'react'
import { useBreadcrumbsData } from 'Common/Breadcrumbs/Breadcrumbs.data'
import { columnsWithFileMap } from './DataQualityColumnDefinitions'
import { ClickThroughColumns } from './DataQuality.types'

export const DataQualityCheckPage = () => {
  useBreadcrumbsData({
    plan_id: '',
  })
  const { data: dataQuality, isLoading } = useDataQuality()
  const [isDataQualityModalOpen, setIsDataQualityModalOpen] = useState(false)
  const [selectedColumn, setSelectedColumn] = useState<
    ClickThroughColumns | ''
  >('')
  const onFail = () => {
    toast.error(`Failed to fetch ${selectedColumn} data`)
  }
  const {
    mutate: fetchColumnData,
    isLoading: isColumnDataLoading,
    data: columnData,
  } = useFetchColumnData(onFail)

  const handleColumnClick = (params: GridCellParams) => {
    const { row, field } = params
    const parquetFile =
      columnsWithFileMap[field as keyof typeof columnsWithFileMap]
    if (parquetFile) {
      setSelectedColumn(parquetFile as ClickThroughColumns)
      setIsDataQualityModalOpen(true)
      fetchColumnData({
        column: parquetFile,
        workCentreKey: row?.workCentreKey,
        workCentreCode: row?.workCentreCode,
      })
    }
  }
  if (isLoading) {
    return <Loader />
  }

  return (
    <Page>
      <Box display="flex" flexDirection="column" flex={1}>
        <PageHeader title="Data quality"></PageHeader>
        <Box>
          <DataQualityMUITable
            data={dataQuality}
            isLoading
            handleColumnClick={handleColumnClick}
          />
        </Box>
      </Box>
      <DataQualityCheckModal
        isModalOpen={isDataQualityModalOpen}
        handleModalClose={() => setIsDataQualityModalOpen(false)}
        isDataLoading={isColumnDataLoading}
        data={columnData?.data ?? []}
        column={selectedColumn}
      />
    </Page>
  )
}
